import type { ProgramId, TimetableId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

export const useTimetableDetail = (
  programId: ProgramId,
  timetableId: TimetableId,
  options?: SWRConfiguration,
) => {
  const client = useGyymClient()
  return useGyymSWR(
    [client.user.programs.getTimetable, programId, timetableId],
    options,
  )
}
